import dynamic from 'next/dynamic';
import { ReactElement } from 'react';
import { SimpleHeroProps } from '../Hero/SimpleHeroLeftImageRightText';

const Comp = dynamic(() => import('./SimpleHeroLeftImageRightText'));

export default function SimpleHeroRightImageLeftText(props: SimpleHeroProps): ReactElement {
  return <Comp {...props} rightImage={true} />;
}
